import React from 'react';
function Instagram({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect width="16.7" height="16.7" x="3.65" y="3.65" rx="4.259" />
      <circle cx="12" cy="12" r="3.441" />
      <path d="M16.695 7.594a.445.445 0 100-.89.445.445 0 000 .89z" />
    </svg>
  );
}

export default Instagram;
